import audioUtil from "./audioUtil";
import emojiStrip from "emoji-strip";
class TextAccumulatorUtil {
    constructor() {
        this.accumulatedText = ""
    }

    init() {
        this.accumulatedText = ""
    }

    stripHtml(html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        temp.querySelectorAll('a.source-link-number').forEach(el => el.remove());
        return temp.textContent || temp.innerText;
    }
    
    accumulateText(updatedVal, speakText = true) {
        const cleanedText = this.stripHtml(updatedVal);
        this.accumulatedText += cleanedText;
        if (!speakText) return;
        this.processAccumulatedTextRecursively();
    }
    processAccumulatedTextRecursively() {
        const endPatterns = ['. ', '? ', '; ' , ': '];
        
        let firstEndIndex = -1;
        let endingPattern = '';
        
        for (const pattern of endPatterns) {
            const index = this.accumulatedText.indexOf(pattern);
            if (index !== -1 && (firstEndIndex === -1 || index < firstEndIndex)) {
                firstEndIndex = index;
                endingPattern = pattern;
            }
        }
        if (firstEndIndex === -1) {
          return; 
        }
        const firstSentence = this.accumulatedText.substring(0, firstEndIndex + endingPattern.length);
        const remainingText = this.accumulatedText.substring(firstEndIndex + endingPattern.length);
        audioUtil.playText(emojiStrip(firstSentence), false);
        this.accumulatedText = remainingText;
        if (this.accumulatedText.trim()) {
          this.processAccumulatedTextRecursively();
        }
    }

    playLastChunk() {
        const playText = emojiStrip(this.accumulatedText);
        if (!playText.trim()) {
            audioUtil.playText('', true);
            this.accumulatedText = '';
            return;
        }
        const endPatterns = ['. ', '? ', '; ' , ': '];
        let hasEndPattern = false;
        for (const pattern of endPatterns) {
            if (playText.includes(pattern)) {
                hasEndPattern = true;
                break;
            }
        }
        if (hasEndPattern) {
            this.processAccumulatedTextRecursively();
            const finalText = emojiStrip(this.accumulatedText);
            if (finalText.trim()) {
                audioUtil.playText(finalText, true);
            }
            else {
                audioUtil.playText('', true);
            }
            this.accumulatedText = '';
        } else {
            audioUtil.playText(playText, true);
            this.accumulatedText = '';
        }
    }
}

export default new TextAccumulatorUtil();

